import { render } from "./GeneralCouncil.vue?vue&type=template&id=566eaacf&scoped=true"
import script from "./GeneralCouncil.vue?vue&type=script&lang=js"
export * from "./GeneralCouncil.vue?vue&type=script&lang=js"

import "./GeneralCouncil.vue?vue&type=style&index=0&id=566eaacf&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-566eaacf"]])

export default __exports__